import type { CancellationReason } from "@/lib/bookings-api";

export interface WithdrawalReasonValidation {
  valid: boolean;
  reasonId: number | null;
  details: string | undefined;
  detailsRequired: boolean;
}

/**
 * Keeps the withdrawal submit gate independent of the modal so both the
 * disabled CTA and the mutation use exactly the same selected canonical row.
 */
export function validateWithdrawalReason(
  reasons: CancellationReason[],
  reasonId: number | null,
  details: string,
): WithdrawalReasonValidation {
  const selected = reasons.find((reason) => reason.id === reasonId);
  const trimmedDetails = details.trim();
  const detailsRequired = selected?.details_required === true;

  return {
    valid: !!selected && (!detailsRequired || !!trimmedDetails),
    reasonId: selected?.id ?? null,
    details: trimmedDetails || undefined,
    detailsRequired,
  };
}

/** Only fully successful mutations may remove a checkout date conflict. */
export function remainingWithdrawalConflictIds(
  tripIds: number[],
  successfulTripIds: ReadonlySet<number>,
): number[] {
  return tripIds.filter((tripId) => !successfulTripIds.has(tripId));
}